export class ViewEnterpriseDashboardPerformanceLocation {
	public id: string;
	public originContractLocationId: string;
	public locationAddress1: string;
	public locationAddress2: string;
	public locationCity: string;
	public locationStateShort: string;
	public locationZipCode: string;
	public supplierName: string;
	public contractBaseRate: number;
	public usage: number;
	public hedgedUsage: number;
	public supplyRate: number;
	public supplyCost: number;
	public utilityRate: number;
	public utilityCost: number;
	public costAvoidance: number;
	public costAvoidancePercentage: number;
	public isUsageEstimated: boolean;
	public isSupplyRateEstimated: boolean;
	public isSupplyCostEstimated: boolean;
	public isUtilityRateEstimated: boolean;
	public isUtilityCostEstimated: boolean;
	public isCostAvoidanceEstimated: boolean;

	constructor(viewEnterpriseDashboardPerformanceLocation: ViewEnterpriseDashboardPerformanceLocation) {
		Object.assign(this, viewEnterpriseDashboardPerformanceLocation);
	}
}
